import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "main-content",
  style: {"overflow-y":"none"}
}
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "tab-content w-100" }
const _hoisted_5 = {
  class: "row m-0 bg-card-light",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_6 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = {
  class: "font-size-16 font-grey p-cursor",
  onclick: "location.href='https://map.admin.caprock.com.au/edit-customer/54?type=view'"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"35px","margin":"0 15px"},
  src: "https://map.admin.caprock.com.au/inlancer-admin/images/users-sqr.svg"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  style: {"color":"#6B7A99"}
}
const _hoisted_11 = {
  key: 1,
  style: {"color":"#6B7A99"}
}
const _hoisted_12 = { class: "col-md-6 d-flex justify-content-center align-items-center py-4" }
const _hoisted_13 = { class: "nav justify-content-center" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Profile", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey active" }, "External Banks", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Managing Members", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Beneficial Owners", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", { class: "font-grey" }, "Accounts", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 d-flex justify-content-end align-items-center py-4" }, null, -1)
const _hoisted_30 = {
  class: "tab-pane fade show active",
  id: "pills-profile",
  role: "tabpanel",
  "aria-labelledby": "pills-currency-tab"
}
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "row mt-5 mx-1 p-3 bg-white border-radius-10" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mt-5 mx-1" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-grey font-size-16" }, "External bank accounts")
], -1)
const _hoisted_35 = { class: "col-md-12 row mb-5 pb-5 mx-1" }
const _hoisted_36 = { class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center" }
const _hoisted_37 = {
  width: "100%",
  class: "table table-striped"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "btn btn-dark pw4 font-size-10 text-uppercase" }
const _hoisted_40 = { style: {"font-size":"clamp(12px,2rem,15px)","padding-left":"5px"} }
const _hoisted_41 = { class: "font-1-9 mt-2" }
const _hoisted_42 = {
  key: 0,
  class: "font-gray2",
  style: {"line-height":"4px"}
}
const _hoisted_43 = { class: "font-black" }
const _hoisted_44 = {
  class: "font-gray2",
  style: {"line-height":"4px"}
}
const _hoisted_45 = {
  class: "font-gray2",
  style: {"line-height":"4px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, [
                    _hoisted_9,
                    (_ctx.user_info.u_type!=2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_10, _toDisplayString(_ctx.user_info.user_name), 1))
                      : _createCommentVNode("", true),
                    (_ctx.user_info.u_type==2)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_11, _toDisplayString(_ctx.user_info.user_company_name), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", _hoisted_13, [
                  _createElementVNode("li", _hoisted_14, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      href: "javascript:;",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/my-profile')))
                    }, _hoisted_16)
                  ]),
                  _createElementVNode("li", _hoisted_17, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      "aria-current": "page",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/bank-accounts'))),
                      href: "javascript:;"
                    }, _hoisted_19)
                  ]),
                  (_ctx.user_info.is_directors==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/managing-members'))),
                          href: "javascript:;"
                        }, _hoisted_22)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.user_info.is_owners==1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                        _createElementVNode("a", {
                          class: "nav-link",
                          "aria-current": "page",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/beneficial-owners'))),
                          href: "javascript:;"
                        }, _hoisted_25)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_26, [
                    _createElementVNode("a", {
                      class: "nav-link",
                      href: "javascript:;",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/my-accounts')))
                    }, _hoisted_28)
                  ])
                ])
              ]),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("table", _hoisted_37, [
                          (_ctx.bank_accounts.length)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bank_accounts, (ac) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: ac.bank_id,
                                    class: "col-md-12 px-4 my-2",
                                    style: {"border-bottom":"0.5px solid #80808047"}
                                  }, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("button", _hoisted_39, _toDisplayString(ac.currency_symbol) + " " + _toDisplayString(ac.currency), 1),
                                      _createElementVNode("b", _hoisted_40, _toDisplayString(ac.bank_name) + " - " + _toDisplayString(ac.bank_account_no) + "   ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                      (ac.bank_bsb!='' && ac.bank_bsb!=null)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_42, [
                                            _createTextVNode(" BSB. - "),
                                            _createElementVNode("span", _hoisted_43, _toDisplayString(ac.bank_bsb), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("p", _hoisted_44, " SwiftCode : " + _toDisplayString(ac.bank_swift_code), 1),
                                      _createElementVNode("p", _hoisted_45, " Address: " + _toDisplayString(ac.bank_address), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}